'use strict';
var parent = require('../../stable/instance/fill');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/fill.js
// module id = 530
// module chunks = 13